
import React from "react";

export default class SectionLoading extends React.Component {
    render() {
        const { sectionClass } = this.props;
        return (
            <div style={this.props.style} className={"section-loading-container row " + (sectionClass ? sectionClass : "")}>
                <div className="col-12 align-self-center">
                    <div className="spinner">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                    </div>
                </div>
            </div>
        );
    }
}